<div *ngIf="informantForm">
    <div *ngIf="questionIndex === 0">
        <div [formGroup]="informantForm" class="mt-1">
            <div class="form-group row">
                <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                <div class="col-9">
                    <input type="text" (change)="setQuestionInformant(informantForm.value.question)"
                        (change)="copyArr()" class="form-control" id="question" formControlName="question"
                        autocomplete="off" ngDefaultControl>

                    <span *ngIf="informantForm.value.media?.file_name">
                        <span style="display: inline;">
                            {{ informantForm.value.media.file_name }}
                        </span>
                        <button mat-icon-button style="display: inline;" (click)="deleteImgQuestion(informantForm)">
                            <span class="text-danger">✖</span>
                        </button>
                    </span>
                </div>
                <div class="col-1">
                    <button mat-mini-fab class="img" (click)="fileInput.click()"
                        style="border-radius: 0; box-shadow: none;"
                        [style.backgroundImage]="'url(\'../../../../assets/multimedia.png\')'">
                        <input #fileInput type="file" accept=".png, .jpg, .jpeg, .mp4, .mp3, .wav"
                            (change)="addQuestionMedia($event, informantForm)" style="display:none;" />
                    </button>
                </div>
            </div>
            <div *ngIf="questionMediaType === 'mp4' || questionMediaType === 'mp3' || questionMediaType === 'wav' || questionMediaType === 'vdo' || questionMediaType === 'sound'"
                class="form-group row" formGroupName="media">
                <label
                    class="col-6 col-form-label">จำนวนรอบที่วิดีโอ/เสียงสามารถเปิดซ้ำได้<lifedi-require></lifedi-require></label>
                <div class="col-2">
                    <input [attr.disabled]="informantForm.value.media.unlimit ? true : null" class="form-control"
                        formControlName="time_again" type="number" min="0" width="100px"
                        (change)="setTimeAgain(informantForm, $event)" (change)="copyArr()">
                </div>
                <div class="col">
                    <mat-checkbox id="unlimit" class="col-form-label" color="primary" formControlName="unlimit"
                        (change)="clearValueDate(informantForm, informantForm.value.media.unlimit)" (change)="copyArr()">
                        ไม่จำกัดรอบ
                    </mat-checkbox>
                </div>
            </div>

            <div *ngFor="let c of informantFormArray.controls; let i = index" formArrayName="choices">
                <div [formGroupName]="i" class="form-group row">
                    <label class="col-1 col-form-label">C{{ i+1 }}<lifedi-require></lifedi-require></label>
                    <input (change)="setChoiceInformant(c.value.choice_detail, i)" class="form-control col-9"
                        formControlName="choice_detail" type="text" (change)="copyArr()">
                    <button mat-mini-fab class="img col-1" (click)="fileInput.click()"
                        style="border-radius: 0; box-shadow: none;"
                        [style.backgroundImage]="'url(\'../../../../assets/picture.png\')'">
                        <input #fileInput type="file" accept=".png, .jpg, .jpeg" (change)="addChoiceMedia($event, c, i)"
                            style="display:none;" />
                    </button>
                    <button mat-mini-fab class="img col-1" (click)="deleteChoice(informantFormArray, i)"
                        [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'">
                    </button>
                    <div *ngIf="c.value.media.file_name" class="offset-1 col-11">
                        <span style="display: inline;">
                            {{ c.value.media.file_name }}
                        </span>
                        <button mat-icon-button style="display: inline;"
                            (click)="deleteImgChoice(informantFormArray, i)">
                            <span class="text-danger">✖</span>
                        </button>
                    </div>
                </div>
            </div>
            <button mat-mini-fab class="img col-1" (click)="addChoiceAndImg(informantFormArray)"
                [style.backgroundImage]="'url(\'../../../../assets/add.png\')'">
            </button>
        </div>
    </div>

    <div *ngIf="questionIndex !== 0">
        <div class="mt-1">
            <div class="form-group row">
                <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                <div class="col-9">
                    <input type="text" class="form-control" id="question" (change)="copyArr()"
                        [(ngModel)]="informantArray[questionIndex - 1].question" autocomplete="off" ngDefaultControl>
                </div>
            </div>

            <div *ngFor="let c of informantArray[questionIndex - 1].choices; let i = index">
                <div class="form-group row">
                    <label class="col-1 col-form-label">C{{ i+1 }}<lifedi-require></lifedi-require></label>
                    <input (change)="copyArr()" class="form-control col-9" [(ngModel)]="c.choice_detail" type="text">
                </div>
            </div>
        </div>

    </div>
</div>